import type { FlowGraph } from "@/flows/catalog";
import { defineModel } from "../define-model";

export type Flow = {
	id: string;
	workspaceId: string;
	projectId: string;
	name: string;
	description: string;
	graph: FlowGraph;
	version: number;
	publishedVersion: number | null;
	status: "draft" | "active" | "paused";
	lastRunAt: string | null;
	createdById: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		flow: Flow;
	}
}

export const model = defineModel({
	name: "flow",
	load: "eager",
	indexes: ["projectId"],
	defaults: ({ userId, workspaceId, now }) => ({
		workspaceId,
		description: "",
		graph: { nodes: [], edges: [] },
		version: 1,
		publishedVersion: null,
		status: "draft" as const,
		lastRunAt: null,
		createdById: userId,
		archivedAt: null,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) => b.updatedAt.localeCompare(a.updatedAt),
});
